import axios from 'axios';

import { headers, STOCK_JOURNAL } from '../../config';

export function getAllRoles(params) {
    return axios.get(`${STOCK_JOURNAL}/role`, { headers: headers(), params })
}

export function createRole(data) {
    return axios.post(`${STOCK_JOURNAL}/role`, data, { headers: {...headers(), "X-Request-ID": data.idempotentKey }})
}

export function updateRole(data) {
    return axios.put(`${STOCK_JOURNAL}/role/${data.id}`, data, { headers: headers() });
}

export function deleteRole(data) {
    return axios.delete(`${STOCK_JOURNAL}/role/${data.id}`, { headers: headers() });
}

export function getPermissions() {
    return axios.get(`${STOCK_JOURNAL}/user-permissions`, { headers: headers() });
}